if (!customElements.get('lc-phone-bubble')) {
  customElements.define('lc-phone-bubble', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const panel = this.querySelector('.lc-phone__panel');
      const close = this.querySelector('.lc-phone__close');
      const reopen = this.querySelector('.lc-phone__reopen');
      const storageKey = 'lc-phone-collapsed';
      const mobile = window.matchMedia('(max-width: 1023px)');
      const controller = new AbortController();
      const listenerOptions = { signal: controller.signal };
      let desktopCollapsed = false;
      let mobileCollapsed = true;

      const setCollapsed = (collapsed, focus = false) => {
        this.toggleAttribute('data-collapsed', collapsed);
        panel.hidden = collapsed;
        reopen.hidden = !collapsed;
        close.setAttribute('aria-expanded', String(!collapsed));
        reopen.setAttribute('aria-expanded', String(!collapsed));
        if (focus) (collapsed ? reopen : close).focus({ preventScroll: true });
      };

      try {
        desktopCollapsed = sessionStorage.getItem(storageKey) === 'true';
      } catch {
        // The invitation remains usable when browser storage is unavailable.
      }
      setCollapsed(mobile.matches ? mobileCollapsed : desktopCollapsed);

      const stickyBar = document.querySelector('.mc-sticky-cta');
      const updatePosition = () => {
        const height = stickyBar && !stickyBar.classList.contains('is-hidden')
          ? stickyBar.getBoundingClientRect().height
          : 0;
        this.style.setProperty('--lc-phone-bar-height', `${height}px`);
      };
      const resizeObserver = new ResizeObserver(updatePosition);
      const barObserver = new MutationObserver(updatePosition);
      if (stickyBar) {
        resizeObserver.observe(stickyBar);
        barObserver.observe(stickyBar, { attributes: true, attributeFilter: ['class', 'style'] });
      }
      updatePosition();
      mobile.addEventListener('change', () => {
        setCollapsed(mobile.matches ? mobileCollapsed : desktopCollapsed);
        updatePosition();
      }, listenerOptions);

      const toggle = (collapsed) => {
        setCollapsed(collapsed, true);
        if (mobile.matches) {
          mobileCollapsed = collapsed;
          return;
        }
        desktopCollapsed = collapsed;
        try {
          sessionStorage.setItem(storageKey, String(collapsed));
        } catch {
          // Saving the collapsed state is optional.
        }
      };
      close.addEventListener('click', () => toggle(true), listenerOptions);
      reopen.addEventListener('click', () => toggle(false), listenerOptions);
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !panel.hidden) {
          event.preventDefault();
          toggle(true);
        }
      }, listenerOptions);
      this.cleanup = () => {
        controller.abort();
        resizeObserver.disconnect();
        barObserver.disconnect();
      };
    }

    disconnectedCallback() {
      this.cleanup?.();
      this.initialized = false;
    }
  });
}
